import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { PreviewSheetData } from '@app/models';
import { GENERAL_MESSAGES } from '@app/shared/data/messages';

@Component({
    selector: 'app-preview-sheet',
    templateUrl: './preview-sheet.component.html',
    styleUrls: ['./preview-sheet.component.scss'],
    standalone: false
})
export class PreviewSheetComponent implements OnInit {

  @Input('isMobile') isMobile: boolean = false;
  generalMessages = GENERAL_MESSAGES;
  previewSheetData: PreviewSheetData | null = null;
  @Output() confirmationEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('sheetTemp') sheetTemp!: TemplateRef<any>;
  @ViewChild('dialogTemp') dialogTemp!: TemplateRef<any>;
  moreInstruction: boolean = false;
  @Output() clickWarnButtonMessageEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private readonly _bottomSheet: MatBottomSheet, 
    private readonly _matDialog: MatDialog
  ) { }

  ngOnInit(): void {    
    // no initial operations required
  }

  openConfirmSheet(data: PreviewSheetData): void {
    if (data?.title?.length && data?.previewData) {
      this.previewSheetData = data;
      if (!this.isMobile) {
        this._bottomSheet.open(this.sheetTemp, { panelClass: 'preview-sheet', disableClose: true });
      } else {
        this._matDialog.open(this.dialogTemp, { panelClass: 'preview-dialog', disableClose: true });
      }
    } else this.previewSheetData = null;
  }

  confirmSend(value: boolean = false) {
    if (value && this.previewSheetData?.actionR?.disabled) return;
    this.confirmationEvent.emit(value);
    if (!this.isMobile) {
      this._bottomSheet.dismiss();
    } else {
      this._matDialog.closeAll();
    }
    this.previewSheetData = null;
    this.moreInstruction = false;
  }
  
  hasGreaterWarnList(list: string[] | undefined) {
    if (!list) {
      return null;
    }

    return list?.length > 1 ? list[0] : null;
  }

  messageButtonClicked() {
    this.clickWarnButtonMessageEvent.emit(true);
  }
}
